/**
 * @fileoverview Utility function to detect if the current device is a mobile device
 * based on User Agent string matching.
 *
 * @example
 * if (isMobile()) {
 *   // Handle mobile-specific logic
 *   showMobileLayout();
 * } else {
 *   // Handle desktop-specific logic
 *   showDesktopLayout();
 * }
 */

/**
 * @function isMobile
 * @description Checks if the current device is a mobile device
 * @returns {boolean} True if the device is a mobile device, false otherwise
 */
export function isMobile() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
    ]

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem)
    })
}
